import { observable, action } from 'mobx'
import { Request2 } from 'src/common/Request2'
import api from 'src/common/api'
import { isEmpty } from 'lodash'
import { PAGE_SIZE } from '../helpers/constants'

const whitelistDefault = {
   rows: [],
   offset: 0,
   count: 0
}

export class WhitelistStore {
   @observable listWhitelist: any = { ...whitelistDefault }

   @action
   async getWhitelist(params: any = {}) {
      const result = await Request2.getWithToken(api.webhookWhitelist.getList, {
         ...params,
         limit: PAGE_SIZE
      })
      if (!isEmpty(result)) {
         this.listWhitelist = {
            rows: result?.results || [],
            offset: ((result?.page || 1) - 1) * PAGE_SIZE,
            count: result?.totalResults || 0
         }
      }
   }

   @action
   async createWhitelist(body: any) {
      const result = await Request2.postWithToken(body, api.webhookWhitelist.create)
      return result
   }

   @action
   async updateWhitelist(id: string | number, body: any) {
      const DOMAIN = `${api.webhookWhitelist.update}/${id}`
      const result = await Request2.patchWithToken(body, DOMAIN)
      return result
   }

   @action
   async deleteWhitelist(id: string | number) {
      const DOMAIN = `${api.webhookWhitelist.delete}/${id}`
      const result = await Request2.deleteWithToken({}, DOMAIN)
      return result
   }

   @action
   resetStore() {
      this.listWhitelist = { ...whitelistDefault }
   }
}
